import { render } from "./PersonalSetting.vue?vue&type=template&id=2c492434&scoped=true"
import script from "./PersonalSetting.vue?vue&type=script&lang=js"
export * from "./PersonalSetting.vue?vue&type=script&lang=js"

import "./PersonalSetting.vue?vue&type=style&index=0&id=2c492434&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c492434"]])

export default __exports__